import React, { useEffect, useState } from "react";
import "./styles.css";
//external or internal components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFilter,
} from "@fortawesome/free-solid-svg-icons";
import { colors } from "../../common/pallette/colors";
import {
  Box,
  ClickAwayListener,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setGlobalFiltersCount,
} from "../../redux/reducers/common";
import FiltersWrapper from "./filters/filtersWrapper";

const FilterBoxPerformancePlan = () => {
  const [isOpen, setIsOpen] = useState(false);
  const globalFiltersCount = useSelector(
    (state: any) => state.common.globalFiltersCount
  );
  const dispatch = useDispatch();
  const selectedDepartments = useSelector((state:any) => state.common.departmentsFilter);
  const isActions = useSelector((state:any) => state.actionPlan.isActions);
  const selectedArchivedStatuses = useSelector((state:any) => !isActions ? 
                                                state.actionPlan.projectsArchivedFilter : 
                                                state.actionPlan.actionsArchivedFilter);
  const selectedActionsLinkedTo = useSelector((state:any) => state.actionPlan.actionsLinkedToFilter);

  // useEffect(() => {
  //   let count: any = 0;
  //   globalFilters.map((d: any) => {
  //     if (
  //       d.value != "" ||
  //       d.operator == "is empty" ||
  //       d.operator == "is not empty"
  //     ) {
  //       count++;
  //     }
  //   });
  //   // setFilterCount(count);
  //   dispatch(setGlobalFiltersCount(count));
  // }, [globalFilters]);

  useEffect(() => {
    let count: any = 0;
    selectedDepartments?.length > 0 && count++;
    selectedArchivedStatuses?.length > 0 && count++;
    selectedActionsLinkedTo?.length > 0 && count++;
    dispatch(setGlobalFiltersCount(count));
  }, [selectedDepartments, selectedArchivedStatuses, selectedActionsLinkedTo]);

  return (
    <React.Fragment>
      <div className="filterBox" style={{ backgroundColor: colors.grey.light }}>
        <div
          className="filterButton pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <FontAwesomeIcon className="filterIcon icon" icon={faFilter} />
          <span style={{ color: colors.grey.dark }}>Filters</span>
        </div>
        {globalFiltersCount > 0 && (
          <Box
            className={"filterCount"}
            sx={{ backgroundColor: colors.blue.navy }}
          >
            {globalFiltersCount}
          </Box>
        )}
        {isOpen && (
          <ClickAwayListener
            onClickAway={() => {
              setIsOpen(false);
            }}
          >
            <Box className="filterWrapper">
              <FiltersWrapper />
            </Box>
          </ClickAwayListener>
        )}
      </div>
    </React.Fragment>
  );
};

export default FilterBoxPerformancePlan;
